const RESPONSE_TYPE = 'id_token'
const RESPONSE_MODE = 'fragment'
const SCOPES = ['openid', 'email', 'profile', 'embedded']

export default {
  RESPONSE_TYPE,
  RESPONSE_MODE,
  SCOPES
}
